// FILE: frontend/src/components/ScoreBar.jsx
// Individual score bar with purple gradient (Patricia's design)

import React from 'react'

export default function ScoreBar({ label, value }) {
  const numVal = Number(value || 0)
  const isWarn = numVal < 60

  return (
    <div className="sbar-row">
      <div className="sbar-label">{label}</div>
      <div className="sbar-track">
        <div
          className={`sbar-fill ${isWarn ? 'warn' : ''}`}
          style={{ width: `${numVal}%` }}
        />
      </div>
    </div>
  )
}
